// @ts-nocheck
import { HgNaics } from "../../types/taxonomy";
import {
  MarketSpendData,
  SpendBreakdownResult,
} from "../types/companySearch/MI";

/**
 *
 * @returns allMarketSpends rolled up into one for each parentNaics
 */
export const rollUpMarketSpendByIndustry = (
  /** array of all MarketSpendData from the API */
  allMarketSpends: MarketSpendData[],
  /** array of parent naics to roll up into */
  parentNaics: HgNaics[],
  /** map of each naics to their ancestors */
  naicsAncestorMap: Record<string, string[]>
): MarketSpendData[] => {
  const data: MarketSpendData[] = [];

  for (const naics of parentNaics) {
    const spendData: MarketSpendData = {
      naics_2012: naics,
      sumRelativeValues: 0,
      companyCount: 0,
    };

    for (const marketSpend of allMarketSpends) {
      const belongsToCurrentNaics = (
        naicsAncestorMap[marketSpend.naics_2012?.id] || []
      ).includes(naics.id);
      if (!belongsToCurrentNaics) continue;

      spendData.sumRelativeValues += marketSpend.sumRelativeValues;
      spendData.companyCount += marketSpend.companyCount;
    }

    data.push(spendData);
  }

  return data;
};

export const transformToSpendBreakDownData = (
  item: MarketSpendData
): SpendBreakdownResult => {
  return {
    id: item?.naics_2012?.id,
    companies: item.companyCount,
    spend: item.sumRelativeValues,
    dimension: `${item?.naics_2012?.code}: ${item?.naics_2012?.name}`,
  };
};
